import SectionHeading from "@/components/SectionHeading";
import { FAQS } from "@/lib/site-data";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="relative border-t border-white/5 bg-[#0A0C0F] py-28 md:py-36">
      <div className="mx-auto max-w-3xl px-6">
        <SectionHeading
          center
          eyebrow="Questions fréquentes"
          title="Tout ce qu’on nous demande sur les toits"
        />
        <div className="mt-14">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f) => (
              <AccordionItem key={f.id} value={f.id} className="border-white/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${f.id}`}
                  className="text-left font-serif text-lg text-slate-100 hover:text-terra hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${f.id}`} className="text-sm leading-relaxed text-slate-400">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
